import React from 'react'

const Check = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15.267'
    height='11.854'
    viewBox='0 0 15.267 11.854'
  >
    <path
      fill='#fff'
      d='M5.846,12.032a.779.779,0,0,1-1.1,0l-4.4-4.4a1.169,1.169,0,0,1,0-1.653l.551-.551a1.169,1.169,0,0,1,1.653,0L5.295,8.174,12.72.749a1.169,1.169,0,0,1,1.653,0l.551.551a1.169,1.169,0,0,1,0,1.653Zm0,0'
      transform='translate(0 -0.406)'
    />
  </svg>
)

export default Check
